equalheight = (container) ->
  currentTallest = 0
  currentRowStart = 0
  rowDivs = new Array
  $el = undefined
  topPosition = 0
  $(container).each ->
    $el = $(this)
    $($el).height 'auto'
    topPostion = $el.position().top
    if currentRowStart != topPostion
      currentDiv = 0
      while currentDiv < rowDivs.length
        rowDivs[currentDiv].height currentTallest
        currentDiv++
      rowDivs.length = 0
      # empty the array
      currentRowStart = topPostion
      currentTallest = $el.height()
      rowDivs.push $el
    else
      rowDivs.push $el
      currentTallest = if currentTallest < $el.height() then $el.height() else currentTallest
    currentDiv = 0
    while currentDiv < rowDivs.length
      rowDivs[currentDiv].height currentTallest
      currentDiv++
    return
  return

$(window).load ->
  equalheight '.equalheight'
  return
$(window).resize ->
  equalheight '.equalheight'
  return